import { render } from "./TeacherDetailsCardFields.vue?vue&type=template&id=23dd12b1"
import script from "./TeacherDetailsCardFields.vue?vue&type=script&lang=js"
export * from "./TeacherDetailsCardFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__